// PRAT-161: quem dispensa o pedido de e-mail/CPF só é perguntado de novo em
// 30 dias. Guardado por cliente neste aparelho; sem localStorage (aba
// anônima, bloqueio), o pedido simplesmente aparece — nunca trava nada.

export const NUDGE_SNOOZE_DAYS = 30;
const PREFIX = 'pratigo:perfil-dispensado:';
const DAY_MS = 24 * 60 * 60 * 1000;

export function dismissProfileNudge(userId: string | undefined, now: number = Date.now()): void {
  if (!userId) return;
  try {
    localStorage.setItem(PREFIX + userId, String(now));
  } catch {
    // sem armazenamento: segue sem lembrar
  }
}

export function isProfileNudgeSnoozed(
  userId: string | undefined,
  now: number = Date.now()
): boolean {
  if (!userId) return false;
  try {
    const raw = localStorage.getItem(PREFIX + userId);
    const at = raw ? Number(raw) : NaN;
    if (!Number.isFinite(at)) return false;
    if (now - at < NUDGE_SNOOZE_DAYS * DAY_MS) return true;
    localStorage.removeItem(PREFIX + userId);
    return false;
  } catch {
    return false;
  }
}

/** "Cupom pratiGO de R$ 10,00 e 150 pontos no Clube da Pizzaria". */
export function rewardsSentence(labels: string[]): string {
  if (labels.length <= 1) return labels[0] ?? '';
  return `${labels.slice(0, -1).join(', ')} e ${labels[labels.length - 1]}`;
}

export function maskCpf(cpf: string | null | undefined): string {
  const d = (cpf ?? '').replace(/\D/g, '');
  if (d.length !== 11) return '';
  return `***.${d.slice(3, 6)}.${d.slice(6, 9)}-**`;
}
